import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from '../filter.pipe';
import { SideListComponent } from '../side-list/side-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrderByPipe } from '../order-by.pipe';
import { popperVariation, TippyModule, tooltipVariation, withContextMenuVariation } from '@ngneat/helipopper';
import { WeekDayCalendarComponent } from './week-day-calendar/week-day-calendar.component';
import { NgDragDropModule } from 'ng-drag-drop';
import {DragDropModule} from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [ FilterPipe,
    SideListComponent, OrderByPipe, WeekDayCalendarComponent,],
  imports: [
    CommonModule, 
    FormsModule,
    TypeaheadModule.forRoot(),
    NgSelectModule,
    ReactiveFormsModule,
    TippyModule.forRoot({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
        contextMenu: withContextMenuVariation(popperVariation),
      }
    }),
    NgDragDropModule.forRoot(),
    DragDropModule
  ],
  exports:[
    FilterPipe,
    SideListComponent,
    FormsModule,
    TypeaheadModule,
    NgSelectModule,
    ReactiveFormsModule,
    OrderByPipe,
    TippyModule,
    WeekDayCalendarComponent,
    NgDragDropModule,
    DragDropModule
  ]
})
export class SharedmodModule { }
